import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import getUserTransformer from './transformers/user/userTransformer';
import axios, { AxiosResponse } from 'axios';

export default {
  async login({ username, password }: { username: string, password: string }): Promise<any> {
    return window.axios.post(
      '/login_check',
      `_username=${encodeURIComponent(username)}&_password=${encodeURIComponent(password)}`,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
        transformResponse: getUserTransformer()
      }
    );
  },
  async tryToAuthUserByCookie(): Promise<any> {
    return window.axios.get('/check_token', {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async editUserSettings(editedSettings: any) {
    return window.axios.patch('/staff/settings/new', editedSettings, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async loginWithPinCode(placeId: string, pinCode: string) {
    return axios.get(`/staff/login/pin-code/${placeId}/${pinCode}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({ data }: AxiosResponse<string>): string => data);
  },
  async createPinCode(pinCode: string) {
    return window.axios.post('/staff/pin-code/create', {
      pinCode
    }, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async requestRestorePassword(username: string) {
    return axios.post('/auth/request/restore/password', {
      username
    }, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async restorePassword({ token, ...passwords }: any) {
    return axios.post(`/auth/restore/password/${token}`, passwords, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  }
};
